module.exports = "<div class=\"weui_media_hd\"><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/media/media-header.vue
 ** module id = 160
 ** module chunks = 0
 **/